import Tools from "./tools";

const URI = new (class {
    getPrefix() {
       const paths = window.location.pathname.split("/");
       if(paths.length < 2 || paths[1].length === 0) return "";
       return "/" + paths[1];
    }

    getShareLink(share_name, share_id) {
        let prettified_name = Tools.prettifiyShareName(share_name);
        return (
            "/share/" +
            encodeURIComponent(prettified_name) +
            "/" +
            encodeURIComponent(share_id)
        );
    }


    getStockLink(stock) {
        return this.getPrefix() + "/stock/" + stock;
    }

    prettifiyShareName(share_name) {
        let prettified_share_name = share_name.
            toLowerCase().
            replace(/\u00e4/g, 'ae').
            replace(/\u00f6/g, 'oe').
            replace(/\u00fc/g, 'ue').
            replace(/\u00df/g, 'ss').
            replace('-', '').
            replace(/-/g, '').
            replace(/ /g, '-').
            replace(/([^a-zA-Z0-9-])/g, '').
            replace(/--/g, '-');
        return prettified_share_name;
    }
})();

export default URI;